<div *ngIf="vo$ | async; let vo" class="subscription-public-metadata">
		<form
			*ngIf="!vo.isInViewMode"
			[formGroup]="publicMetadataForm.form"
			class="subscription-public-metadata__form-config">
			<mat-form-field [appearance]="Appearance">
				<mat-label
					i18n="@@subscription.publicMetadata.form.title">
					title</mat-label>
				<input
					type="text"
					id="{{ cmpId + '-title-input' }}"
					matInput
					[formControlName]="PublicMetadataFormControls.Title" />
				<mat-hint [align]="'end'">
					{{
						publicMetadataForm.form
							.get(PublicMetadataFormControls.Title)?.value?.length || 0
					}}/{{Configuration.maxLengthLabel}}
				</mat-hint>
				<mat-error
					*ngIf="
						publicMetadataForm.form
							.get(PublicMetadataFormControls.Title)
							?.hasError(ValidationErrorKeys.Maxlength)
					"
					i18n="@@general.form.errors.maxlength">
					max length
				</mat-error>
				<mat-error
					*ngIf="
					publicMetadataForm.form
						.get(PublicMetadataFormControls.Title)
						?.hasError(ValidationErrorKeys.Pattern)
				"
					i18n="@@general.form.errors.unauthorizedCharacters">
					unauthorized-characters
				</mat-error>
				<mat-error
					*ngIf="
						publicMetadataForm.form
							.get(PublicMetadataFormControls.Title)
							?.hasError(ValidationErrorKeys.Required)
					"
					i18n="@@general.form.errors.required">
					required
				</mat-error>
			</mat-form-field>

			<mat-form-field [appearance]="Appearance">
				<mat-label
					i18n="@@subscription.publicMetadata.form.description">
					description</mat-label>
				<textarea
					[rows]="4"
					type="text"
					id="{{ cmpId + '-details-input' }}"
					matInput
					[formControlName]="PublicMetadataFormControls.Description"></textarea>
				<mat-hint [align]="'end'">
					{{
						publicMetadataForm.form
							.get(PublicMetadataFormControls.Description)?.value?.length || 0
					}}/{{Configuration.maxLengthDescription}}
				</mat-hint>
				<mat-error
					*ngIf="
						publicMetadataForm.form
							.get(PublicMetadataFormControls.Description)
							?.hasError(ValidationErrorKeys.Maxlength)
					"
					i18n="@@general.form.errors.maxlength">
					max length
				</mat-error>
			</mat-form-field>

			<app-tag-configurator
				[configuredTags]="vo.publicMetadata.keywords | toArray"
				(hasChangedValue)="hasKeyWordsChanged()"
				configMode="ActiveEdit"
				displayMode="keywords"></app-tag-configurator>

		</form>

		<div
			*ngIf="vo.isInViewMode"
			class="subscription-public-metadata__view-mode">
			<!-- TITLE -->
			<div class="public-metadata__title">
				<div
					class="subscription-public-metadata__label">
					<span
						i18n="@@subscription.publicMetadata.form.title">
						label</span>
				</div>
				<div>
					<span
						[matTooltip]="vo.publicMetadata.title"
						[matTooltipDisabled]="vo.publicMetadata.title.length <= Configuration.maxLengthSubPublicMetadataTitleDisplay"
						matTooltipPosition="right">
						{{vo.publicMetadata.title | truncate: Configuration.maxLengthSubPublicMetadataTitleDisplay : 1 : 'end'}}</span>
				</div>
			</div>

			<!-- DESCRIPTION -->
			<div class="public-metadata__description"
					 *ngIf="vo.publicMetadata.description">
				<div
					class="subscription-public-metadata__label">
					<span
						i18n="@@subscription.publicMetadata.form.description">
						description</span>
				</div>
				<div>
					<span
						[matTooltip]="vo.publicMetadata.description"
						[matTooltipDisabled]="vo.publicMetadata.description.length <= Configuration.maxLengthSubPublicMetadataDescriptionDisplay"
						matTooltipPosition="right">
					{{vo.publicMetadata.description | truncate: Configuration.maxLengthSubPublicMetadataDescriptionDisplay : 5 : 'end'}}</span>
				</div>
			</div>

			<!-- KEYWORDS -->
			<div class="public-metadata__keywords"
					 *ngIf="vo.publicMetadata.keywords.size !== 0">
				<div
					class="subscription-public-metadata__label">
					<span
						i18n="@@subscription.publicMetadata.form.keywords">
						keywords</span>
				</div>
				<app-tag-configurator
					displayMode="keywords"
					configMode="View"
					[configuredTags]="vo.publicMetadata.keywords | toArray">
				</app-tag-configurator>
			</div>

		</div>
</div>
